import { palette } from '@dev/ee-components';
import styled from 'styled-components';

export const VideoOverlayWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
`;

export const CloseIconContainer = styled.div`
    width: 100%;
    height: 68px;
    svg {
        fill: ${palette.basic.paper};
        top: 24px;
        right: 24px;
        width: 24px;
        height: 24px;
        position: absolute;
        cursor: pointer;
    }
`;

export const StyledIframe = styled.iframe`
    max-width: 923px;
    max-height: 530px;
    width: 100%;
    height: 100%;
    border: none;
`;

export const Overlay = styled.div`
    position: relative;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    height: 100%;
    justify-content: center;
    align-items: center;

    .MuiContainer-root {
        padding-top: 60px;
        position: relative;
        z-index: 1;
        opacity: 0.6;
    }
`;
